import { Toolbar } from '@mui/material';

type IncPageHeaderProps = {
  children: React.ReactNode;
  'data-testid'?: string;
};

const IncPageHeader = ({
  children,
  'data-testid': dataTestId = 'IncPageHeader',
  ...rest
}: IncPageHeaderProps) => {
  return (
    <Toolbar data-testid={dataTestId} {...rest} sx={{ '&&': { px: 2 } }}>
      {children}
    </Toolbar>
  );
};

export default IncPageHeader;
